import React, { FC, MouseEvent, useContext } from 'react'
import Menu from '@material-ui/core/Menu'
import { Box } from '@material-ui/core'
import MenuItem from 'components/base/MenuItem'
import { CLIP_CREATOR_CONTEXT_MENU } from 'config/constants/preview'
import { ClipCreatorMarkType } from 'types/preview'
import { useSelector } from 'react-redux'
import { selectViewSettings } from 'selectors/mainView'
import { ViewSettings } from 'config/constants/editorSettings'
import { TranslationContext } from 'contexts/TranslationContext'
import 'components/Preview/ClipCreator/ClipCreator.scss'

interface IProps {
  anchorEl: HTMLDivElement | null
  onMarkOut(e: MouseEvent): void
  onMarkIn(e: MouseEvent): void
  onClearInOutPoints(e: MouseEvent): void
  onCloseMenu(e: MouseEvent): void
  anchorPosition: {top: number, left: number}
}

export const TimelineHeaderContextMenu: FC<IProps> = ({
  onCloseMenu,
  anchorEl,
  anchorPosition,
  ...rest
}) => {
  const { t } = useContext(TranslationContext)
  const viewSettings = useSelector(selectViewSettings)
  if (!viewSettings[ViewSettings.showInOutPointsTimeline]) {
    return null
  }

  return (
    <Menu
      keepMounted
      anchorEl={anchorEl}
      anchorPosition={anchorPosition}
      anchorReference="anchorPosition"
      classes={{ paper: 'clip-creator__dropdown-menu' }}
      open={!!anchorEl}
      onClose={onCloseMenu}
    >
      {(Object.entries(CLIP_CREATOR_CONTEXT_MENU) as [ClipCreatorMarkType, {
        TITLE: string,
        HOTKEY: string,
        CALLBACK_NAME: 'onMarkOut' | 'onMarkIn' | 'onClearInOutPoints',
      }][]).map(([ marker, menuItem ]) => (
        <div className="clip-creator__dropdown-menu-item dropdown-menu-item" key={marker}>
          <MenuItem
            className="dropdown-menu-item__body"
            onClick={rest[menuItem.CALLBACK_NAME]}
          >
            <Box width="100%" display="flex" justifyContent="space-between">
              <span>{t(menuItem.TITLE)}</span>
              <span className="dropdown-menu-item__hotkey">{menuItem.HOTKEY}</span>
            </Box>
          </MenuItem>
        </div>
      ))}
    </Menu>
  )
}
